/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/14/19
 * Time: 12:05 PM
 */
import React, {Component} from 'react';
import Update from "./Update/Update";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {MDBDataTable} from "mdbreact";
import {Button as SementicBtn} from "semantic-ui-react";
import './ViewCorporateAdmin.css'
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {
  state = {
    isUpdate: false,
    corporate_admin_data: null,
    data: [
      // {
      //   id: 'U001',
      //   name: 'Tharindu Athukorala',
      //   email: 'tharindud@ceyentra.com',
      //   username: 'tharindud',
      //   password: '1234',
      //   corporate: 'Ceyentra Technologies',
      //   status: 'ACTIVE'
      // },

    ]
  };
  handleUpdate = () => {
    this.setState({
      isUpdate: !this.state.isUpdate
    })
  };

  updateCorporateAdmin = (obj) => {
    this.handleUpdate();
    this.setState({
      corporate_admin_data: obj
    })
  };

  deleteCorporateAdmin = (admin) => {
    let id = admin.userId;
    let name = admin.userName;

    swal({
      title: "Do you want to delete this corporate admin? First please enter \"" + name + "\"",
      // title:"Do you want to inactive this corporate admin? First please enter \""+name+"\"",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      content: "input",
    })
      .then((value) => {
        if (value === name) {
          this.deleteCorporateAdmin_(id)
          // this.inactiveUser(admin);
        } else {
          common.warningAlert("Can't delete corporate admin", 1)
          // common.warningAlert("Can't inactivate corporate admin", 1)
        }
      });
  };

  inactiveUser = (obj) => {
    let branchesList = [];
    if (obj.branches.length !== 0) {
      obj.branches.map((branch, index) => {
        branchesList.push(branch.branchId)
      })
    }
    const object = {
      "userId": obj.userId,
      "userName": obj.userName,
      "password": "",
      "fullName": obj.fullName,
      "email": obj.email,
      "status": 0,
      "userRoles": "CORP_ADMIN",
      "corporates": obj.corporates.length !== 0 ? [obj.corporates[0].corporateId] : [],
      "branches": branchesList,
      "mobile": obj.mobile
    };

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.post(apiConfig.CORPORATE_SYSTEM_USERS, object, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Corporate admin successfully inactivated", 0);
          this.getData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.inactiveUser(obj)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  deleteCorporateAdmin_ = (id) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axiosTags.delete(apiConfig.CORPORATE_SYSTEM_USER_SELECT(id), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Corporate admin successfully deleted", 0);
          this.getData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.deleteCorporateAdmin_(id)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  viewProfile = async (userObj) => {
    let obj = {};
    obj.corporateId = userObj.corporates.length !== 0 ? userObj.corporates[0].corporateId : 0;
    obj.services = userObj.services !== undefined ? userObj.services : [];
    obj.userName = userObj.userName;
    obj.fullName = userObj.fullName;
    obj.email = userObj.email;
    obj.mobile = userObj.mobile;
    obj.userRoles = userObj.userRoles;
    obj.corporates = userObj.corporates;
    obj.userId = userObj.userId;

    await Cookies.set('3c8bed3b2d6ba6d3076ee8d2f588a4dd', obj);
    window.open('/corporate/dashboard', '_blank');
  };
  getData = () => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
    axiosTags.get(apiConfig.CORPORATE_SYSTEM_USERS, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({
            data: response.data.adminUserList
          })
        } else {
          this.setState({
            data: []
          })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getData()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    let rows = [];
    if (this.state.data.length !== 0) {
      this.state.data.map((admin, index) => {
        const obj = {
          email: admin.email,
          name: admin.fullName,
          username: admin.userName,
          corporate: admin.corporates.length !== 0 ? admin.corporates[0].corporateName : "-",
          added_by: admin.addedBy,
          added_datetime: common.convertDate(admin.addedDate),
          last_mod_by: admin.modifyBy !== null ? admin.modifyBy : "-",
          last_mod_datetime: admin.modifyDate !== null ? common.convertDate(admin.modifyDate) : "-",
          status: admin.status === 1 ? "ACTIVE" : "INACTIVE",
          more:
            <div>
              <SementicBtn circular icon='edit' className={"more-update"}
                           onClick={() => this.updateCorporateAdmin(admin)}/>
              <SementicBtn circular icon='trash alternate' className={"more-remove"}
                           onClick={() => this.deleteCorporateAdmin(admin)}/>

            </div>
          ,
          view: <SementicBtn circular icon='eye' color={"facebook"}
                             onClick={() => this.viewProfile(admin)}/>
        };
        rows.push(obj)
      })
    }
    let table_data = {columns, rows};

    return (
      <Row>
        {
          this.state.isUpdate ?
            <Update refreshData={this.getData} closeModal={this.handleUpdate} data={this.state.corporate_admin_data}/>
            : null
        }
        <Col lg="12">
          <Card>
            <CardHeader>
              Corporate Administrators Details
              <div className={"float-right"}>
                <SementicBtn circular icon='refresh' onClick={this.getData}/>
              </div>
            </CardHeader>
            <CardBody>
              <MDBDataTable
                id={"all-corporate-admin-table"}
                searching={true}
                searchLabel={"Search Corporate Admin"}
                responsive
                responsiveSm
                responsiveMd
                responsiveLg
                responsiveXl
                // striped={true}
                bordered
                hover
                data={table_data}/>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const columns = [
  {
    label: 'Email',
    field: 'email',
    sort: 'asc'
  },
  {
    label: 'Full Name',
    field: 'name',
    sort: 'asc'
  },
  {
    label: 'Username',
    field: 'username',
    sort: 'asc'
  },
  {
    label: 'Corporate',
    field: 'corporate',
    sort: 'asc'
  },

  {
    label: 'Added By',
    field: 'added_by',
    sort: 'asc'
  },
  {
    label: 'Added DateTime',
    field: 'added_datetime',
    sort: 'asc'
  },
  {
    label: 'Last Modified By',
    field: 'last_mod_by',
    sort: 'asc'
  },
  {
    label: 'Last Modified DateTime',
    field: 'last_mod_datetime',
    sort: 'asc'
  },
  {
    label: 'Status',
    field: 'status',
    sort: 'asc'
  },
  {
    label: 'More Information',
    field: 'more',
    sort: 'asc'
  },
  {
    label: 'View Profile',
    field: 'view',
    sort: 'asc'
  },
];

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
